<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-24 16:16:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:40:52
-->
<template>
	<el-form :model="formData" label-width="100px" ref="form">
		<el-form-item label="招商方式">
			<el-checkbox-group v-model="formData['shop_type']" @change="shopTypeChange">
				<el-checkbox v-for="item in shopTypeList" :key="item.value" :label="item.label"></el-checkbox>
			</el-checkbox-group>
		</el-form-item>
		<el-form-item label="跨境电商">
			<el-radio-group v-model="formData['threshold_cross_border']">
				<el-radio :label="item.label" :value="item.value" v-for="item in threshold_cross_borderList" :key="item.value"></el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="新手店铺">
			<el-radio-group v-model="formData['is_new_shop']">
				<el-radio :label="item.label" :value="item.value" v-for="item in newShopList" :key="item.value"></el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="商家体验分">
			<el-radio-group v-model="formData['shop_score']">
				<el-radio :label="item.label" :value="item.value" v-for="item in shopScoreList" :key="item.value"></el-radio>
			</el-radio-group>
		</el-form-item>
	</el-form>
</template>
<script>
import mixin from '../../../../mixin';
export default {
	name: 'LimitForm',
	mixins: [mixin],
	data() {
		return {
			formData: {
				shop_type: ['不限'],
				threshold_cross_border: '可报名',
				is_new_shop: '可报名',
				shop_score: '不限',
			},
			shopTypeList: [
				{
					value: -1,
					label: '不限',
				},
				{
					value: 0,
					label: '普通店',
				},
				{
					value: 1,
					label: '专营店',
				},
				{
					value: 2,
					label: '旗舰店',
				},
				{
					value: 3,
					label: '专卖店',
				},
				{
					value: 5,
					label: '商场店',
				},
				{
					value: 6,
					label: '专卖型旗舰店',
				},
				{
					value: 7,
					label: '官方旗舰店',
				},
				{
					value: 8,
					label: '企业店',
				},
				{
					value: 9,
					label: '个体店',
				},
			],
			threshold_cross_borderList: [
				{
					value: 0,
					label: '可报名',
				},
				{
					value: 1,
					label: '不可报名',
				},
			],
			newShopList: [
				{
					value: true,
					label: '可报名',
				},
				{
					value: false,
					label: '不可报名',
				},
			],
			shopScoreList: [
				{
					value: 0,
					label: '不限',
				},
				{
					value: 1,
					label: '≥4',
				},
				{
					value: 2,
					label: '≥4.3',
				},
				{
					value: 3,
					label: '≥4.5',
				},
				{
					value: 4,
					label: '≥4.8',
				},
			],
		};
	},
	methods: {
		validate() {
			return new Promise(resolve => {
				const _form = { ...this.formData };
				_form.is_new_shop = this.newShopList.find(item => item.label === _form.is_new_shop).value;
				_form.threshold_cross_border = this.threshold_cross_borderList.find(item => item.label === _form.threshold_cross_border).value;
				_form.shop_type = _form.shop_type.map(item1 => this.shopTypeList.find(item => item.label === item1).value).join(',');
				_form.shop_score = this.shopScoreList.find(item => item.label === _form.shop_score).value;
				resolve(_form);
			});
		},
		resetForm() {
			this.$refs.form.resetFields();
		},
		shopTypeChange(list) {
			if (list.length > 1) {
				if (list[0] === '不限') {
					list.shift();
					this.shop_type = list;
				}
				if (list[list.length - 1] === '不限') {
					this.shop_type = ['不限'];
				}
			}
		},
		isFormModified() {
			return this.isModified;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/.el-checkbox {
	margin-right: 20px;
}
</style>
